export default {
    navigationBarTitleText: intl.get('mobileLandingPage.title.pad'),
    navigationBarBackgroundColor: "#DF773C",
};
